<i class="bi bi-arrow-90deg-left" *ngIf="path" [routerLink]="path"></i>
<i class="bi bi-arrow-90deg-left" *ngIf="!path"></i>
